// 园区数据
import Log from "../view/log";
import DataParkBasic from "../view/DataServicePark/DataParkBasic/DataParkBasic";
import ProductionTaxStatistics from "../view/DataServicePark/ProductionTaxStatistics/ProductionTaxStatistics";
import ProductionTaxStatisticsAdd from "../view/DataServicePark/ProductionTaxStatistics/ProductionTaxStatisticsAdd";
import ProductionTaxStatisticsModify from "../view/DataServicePark/ProductionTaxStatistics/ProductionTaxStatisticsModify";
import DataParkHonor from "../view/DataServicePark/DataParkHonor/DataParkHonor";
import DataParkHonorAdd from "../view/DataServicePark/DataParkHonor/DataParkHonorAdd";
import DataParkHonorModify from "../view/DataServicePark/DataParkHonor/DataParkHonorModify";
import EnterpriseCultivation from "../view/DataServicePark/EnterpriseCultivation/EnterpriseCultivation";
import EnterpriseCultivationAdd from "../view/DataServicePark/EnterpriseCultivation/EnterpriseCultivationAdd";
import EnterpriseCultivationModify from "../view/DataServicePark/EnterpriseCultivation/EnterpriseCultivationModify";
import UpscaleElements from "../view/DataServicePark/UpscaleElements/UpscaleElements";
import UpscaleElementsAdd from "../view/DataServicePark/UpscaleElements/UpscaleElementsAdd";
import UpscaleElementsModify from "../view/DataServicePark/UpscaleElements/UpscaleElementsModify";
import DataServiceNav from "../view/DataServicePark/DataServiceNav";

export default [
  /* 新数据 */
  {
    path: "/data_park_basic",
    name: "data-park-basic",
    components: {
      default: DataServiceNav,
      a: DataParkBasic
    }
  },
  {
    path: "/data_park_honor",
    name: "data-park-honor",
    components: {
      default: DataServiceNav,
      a: DataParkHonor
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/production_tax_statistics",
    name: "production-tax-statistics",
    components: {
      default: DataServiceNav,
      a: ProductionTaxStatistics
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/production_tax_statistics/add",
    name: "production-tax-statistics-add",
    components: {
      default: DataServiceNav,
      a: ProductionTaxStatisticsAdd
    }
  },
  {
    path: "/production_tax_statistics_modify/:id",
    name: "production-tax-statistics-modify",
    components: {
      default: DataServiceNav,
      a: ProductionTaxStatisticsModify
    }
  },
  {
    path: "/data_park_honor_add",
    name: "data-park-honor-add",
    components: {
      default: DataServiceNav,
      a: DataParkHonorAdd
    }
  },
  {
    path: "/data_park_honor_modify/:id",
    name: "data-park-honor-modify",
    components: {
      default: DataServiceNav,
      a: DataParkHonorModify
    }
  },
  {
    path: "/enterprise_cultivation",
    name: "enterprise-cultivation",
    components: {
      default: DataServiceNav,
      a: EnterpriseCultivation
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/enterprise_cultivation_add",
    name: "enterprise-cultivation-add",
    components: {
      default: DataServiceNav,
      a: EnterpriseCultivationAdd
    }
  },
  {
    path: "/enterprise_cultivation_modify/:id",
    name: "enterprise-cultivation-modify",
    components: {
      default: DataServiceNav,
      a: EnterpriseCultivationModify
    }
  },
  {
    path: "/upscale_elements",
    name: "upscale-elements",
    components: {
      default: DataServiceNav,
      a: UpscaleElements
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/upscale_elements_add",
    name: "upscale-elements-add",
    components: {
      default: DataServiceNav,
      a: UpscaleElementsAdd
    }
  },
  {
    path: "/upscale_elements_modify/:id",
    name: "upscale-elements-modify",
    components: {
      default: DataServiceNav,
      a: UpscaleElementsModify
    }
  },
  /* 新数据 */
  // 新数据操作日志
  {
    path: "/data_service_log",
    name: "data-service-log",
    components: {
      default: DataServiceNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/DataServicePark.js